import { errorSafe } from 'app/infrastructure/redux/error-safe';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import * as actions from './action-types';
import { api } from './api';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages/action-types';
import { downloadFile } from 'app/infrastructure/platform/file';

export const actionCreators = {

  loadReportStatus: (): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: () => ApplicationState) => {
      const myDownloadsState = getState().myDownloads;

      if (myDownloadsState.reportsView.fetchingReportStatus) {
        return;
      }

      dispatch(new actions.RequestReportStatus());
      try {
        const reportStatus = await api.loadReportStatus();
        dispatch(new actions.ReceiveReportStatus(reportStatus));
      } catch {
        dispatch(new actions.FailReportStatus());
      }
    }),

  downloadReportPackage: (reportId: any, fileExtension: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {
      dispatch(new actions.RequestDownloadReportPackage(reportId));
      try {
        const response = await api.downloadReportPackage(reportId);
        downloadFile(response.blob, 'report-' + reportId + (fileExtension ? '.' + fileExtension : ''));
        dispatch(new actions.ReceiveDownloadReportPackage(reportId));
      } catch (err) {
        dispatch(new ErrorNotification(err.userMessages || err.message));
        dispatch(new actions.FailDownloadReportPackage(reportId));
      }
    }
};
